import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './BloodPressureRecord.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import Modal from '../../../../components/comm/Modal';
import ToastPopup from '../../../../components/comm/ToastPopup';
import noDataImg from '../../../../images/common/i_3d_no_data_doc.svg';
import imgWatch from '../../../../images/common/i_watch_blue.svg';
import URL from '../../../../constants/url';
import BloodPressureRecordBox from '../../../../components/home/bloodpress/BloodPressureRecordBox';
import LineGraphBox from '../../../../components/home/LineGraphBox';
import BottomSheetBase from '../../../../components/comm/BottomSheetBase';
import axiosApi from '../../../../api/daonAxios';
import { BP_ACCESS, useWatchBpSync } from '../../../../hook/useWatchBpSync';
import { openSamsungHealthStore } from '../../../../bridge/healthBridge';

import CODE from '../../../../constants/code';
import { useNavigate, useLocation } from 'react-router-dom';

import Skeleton from '@mui/material/Skeleton';


const BloodPressureRecord = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [recordList, setRecordList] = useState([]);
    const [systolicList, setSystolicList] = useState([]);
    const [diastolicList, setDiastolicList] = useState([]);
    const [graphRecords, setGraphRecords] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    // 삼성 헬스 권한 허용 팝업 
    const [permOpen, setPermOpen] = useState(false);

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [visibleCount, setVisibleCount] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    const [isInitialLoading, setIsInitialLoading] = useState(true);

    const [guideOpen, setGuideOpen] = useState(false);

    const confirmDelete = (index) => {
        setDeleteIndex(index);
        setIsOpen(true);
    };

    const handleConfirmDelete = () => {
        if (deleteIndex !== null) {
            handleDelete(deleteIndex);
            setDeleteIndex(null);
        }
        setIsOpen(false);
    };

    const parseDateTime = (dateStr, timeStr) => {
        const year = parseInt(dateStr.substring(0, 4), 10);
        const month = parseInt(dateStr.substring(4, 6), 10) - 1;
        const day = parseInt(dateStr.substring(6, 8), 10);
        const hour = parseInt(timeStr.substring(0, 2), 10);
        const minute = parseInt(timeStr.substring(2, 4), 10);
        const second = parseInt(timeStr.substring(4, 6), 10);
        return new Date(year, month, day, hour, minute, second);
    };

    const updateGraphData = (records) => {
        if (!records || records.length === 0) return;

        const sortedByLatest = [...records].sort((a, b) => {
            return parseDateTime(b.recDe, b.recTm) - parseDateTime(a.recDe, a.recTm);
        });

        const latestThree = sortedByLatest.slice(0, 3);

        const sortedAsc = [...latestThree].sort((a, b) => {
            return parseDateTime(a.recDe, a.recTm) - parseDateTime(b.recDe, b.recTm);
        });

        setSystolicList(sortedAsc.map(r => r.brssrTop));
        setDiastolicList(sortedAsc.map(r => r.brssrLwet));
        setGraphRecords(sortedAsc.map(r => ({
            ...r,
            date: formatDateStr(r.recDe),
            time: convertTimeStr(r.recTm),
        })));
    };

    const handleDelete = (usrBrssrHistId) => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            data : {usrBrssrHistId : usrBrssrHistId},
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        axiosApi.delete('/bp',requestOption)
        .then((res) => {
            setToastMessage('기록이 삭제되었습니다.'); 
            setToast(true); 
            getUsrBrssrHist();
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {
            setIsInitialLoading(false);
        })
    };


    const convertTimeStr = (timeStr) => {
        const hour = timeStr.substring(0, 2);
        const minute = timeStr.substring(2, 4);
        return `${hour}:${minute}`;
    };
    const formatDateStr = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return dateStr;
        const year = dateStr.substring(2, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${year}.${month}.${day}`;
    };
    const formatLatestDateStr = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return dateStr;
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${year}.${month}.${day}`;
    };

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            getUsrBrssrHist();
            return;
        }
    }, []);

    const updateList = (records) => {
        const sortedByLatest = [...records].sort((a, b) => {
            return parseDateTime(b.recDe, b.recTm) - parseDateTime(a.recDe, a.recTm);
        });
        setRecordList(sortedByLatest);
    };

    const getUsrBrssrHist = useCallback(async () => {

        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.get('/bp/list',requestOption)
        .then((res) => {

            const list = res.data.result;
            setRecordList(list);
            updateGraphData(list); 
            updateList(list);
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {
            setIsInitialLoading(false);
        })

    }, []);

    /** 워치 혈압이 새로 들어왔을 때 */
    const handleWatchSynced = useCallback((savedCnt) => {
        getUsrBrssrHist();
        // setToastMessage(`워치 혈압 기록 ${savedCnt}건을 가져왔어요.`);
        setToastMessage(`워치 기록 완료!`);
        setToast(true);
    }, [getUsrBrssrHist]);

    const { access, askPermission } = useWatchBpSync(handleWatchSynced);

    // 시스템 동의 화면 앞에 우리 안내 모달을 먼저 띄운다
    useEffect(() => {
        if (access === BP_ACCESS.NEED_PERMISSION || access === BP_ACCESS.NOT_INSTALLED) {
            setPermOpen(true);
        }
    }, [access]);

    const needsInstall = access === BP_ACCESS.NOT_INSTALLED;

    const handlePermConfirm = () => {
        setPermOpen(false);
        if (needsInstall) openSamsungHealthStore();
        else askPermission();
    };

    useEffect(() => {
        if (location.state?.showToast) {
            setToastMessage(location.state.toastMessage);
            setToast(true);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, location.pathname, navigate]);

    const handleBack = () => {
        navigate(URL.HOME_MAIN, {
            replace: true,
            state: { tabIndex: 1 }
        });
    };

    const loadMore = () => {
        if (isLoading) return;
        setIsLoading(true);
        setTimeout(() => {
            setVisibleCount(prev => Math.min(prev + 10, recordList.length));
            setIsLoading(false);
        }, 300);
    };

    const observerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) loadMore();
            },
            { threshold: 0.1 }
        );
        if (observerRef.current) observer.observe(observerRef.current);
        return () => { if (observerRef.current) observer.unobserve(observerRef.current); };
    }, [recordList, visibleCount]);
    

    const SkeletonLoader = () => (
        <>
            <div className={style['graph-box']}>
                <div className={style['graph-top']}>
                    <Skeleton variant="text" width={150} height={24} />
                    <Skeleton variant="text" width={80} height={24} />
                </div>
                <div className={style['graph-bot']}>
                    <div className={style['inner-box']}>
                        <Skeleton variant="rectangular" width="100%" height={140} style={{ borderRadius: '12px' }} />
                    </div>
                </div>
            </div>
            <div className="inner-wrap">
                <div className={style['record-box-lists']}>
                    <ul>
                        {[...Array(3)].map((_, idx) => (
                            <li key={idx} style={{ width: "100%", height: '120px', padding: '16px', marginBottom: '12px', backgroundColor: '#fff', borderRadius: '12px' }}>
                                <Skeleton variant="text" width={80} height={24} style={{ borderRadius: '4px', marginBottom: '2px' }} />
                                <Skeleton variant="text" width={'80%'} height={20} style={{ borderRadius: '4px', marginBottom: '2px' }} />
                                <Skeleton variant="text" width={'60%'} height={20} style={{ borderRadius: '4px', marginBottom: '2px' }} />
                                <Skeleton variant="text" width={120} height={22} style={{ borderRadius: '4px', marginBottom: '6px' }} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );

    return (
        <>
            <HeadSub title="혈압 기록" onBack={handleBack}
                rightArea={
                    <button className='btn' data-btn-type="fill-main-sub" data-btn-size='sm' onClick={() => setGuideOpen(true)}
                    >
                        <span>혈압기록 가이드</span> 
                    </button>
                }
            />

            <div id="sub-content">
                {isInitialLoading ? (
                    <SkeletonLoader />
                ) : recordList.length === 0 ? (
                    <div className='animation-3'>
                        <div className={style['no-data-box']}>
                            <div className={style['img-box']}>
                                <object data={noDataImg} aria-hidden='true'></object>
                            </div>
                            <p>기록이 없습니다.</p>
                        </div>
                    </div>
                ) :
                    <>
                        <div className={style['graph-box']}>
                            <div className={style['graph-top']}>
                                <p>{formatLatestDateStr(recordList[0].recDe)} {convertTimeStr(recordList[0].recTm)}</p>
                                <ul className={style['legend-box']}>
                                    <li data-status="1"><p>수축기</p><span>{recordList[0].brssrTop}</span></li>
                                    <li data-status="2"><p>이완기</p><span>{recordList[0].brssrLwet}</span></li>
                                </ul>
                            </div>
                            <div className={style['graph-bot']}>
                                <div className={style['inner-box']}>
                                    <ul className={style['line-graph-box']}>
                                        <li>
                                            <LineGraphBox data={{ columns: [systolicList] }} graphColor={["#1065D9"]} height={10} />
                                        </li>
                                        <li>
                                            <LineGraphBox data={{ columns: [diastolicList] }} graphColor={["#00A1A9"]} height={10} />
                                        </li>
                                    </ul>
                                    <div className={style['line-graph-date-box']}>
                                        <ul data-graph-length={recordList.length === 2 ? "twin" : ""}>
                                            {graphRecords.map((item, idx) => (
                                                <li key={idx}>
                                                    <div className={style['date-text']}>
                                                        <p>{formatDateStr(item.recDe)}</p>
                                                        <span>{convertTimeStr(item.recTm)}</span>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="inner-wrap">
                            
                            <div className={style['watch-btn']}>
                                <button className='btn' data-btn-type="fill-main-sub" data-btn-size='smd' data-btn-width='full' onClick={()=> navigate(URL.WATCH_BP_GUIDE)}>  
                                    <img src={imgWatch} alt="워치 혈압 측정 가이드" />
                                    <span> 워치 혈압 측정 가이드 </span>
                                </button>
                            </div>
                            <div className={style['record-box-lists']}>
                                <ul>
                                    {recordList.slice(0, visibleCount).map((item, idx) => (
                                        <li key={idx}>
                                            <BloodPressureRecordBox
                                                systolic={item.brssrTop}
                                                diastolic={item.brssrLwet}
                                                date={formatDateStr(item.recDe)}
                                                time={convertTimeStr(item.recTm)}
                                                source={item.cntcRecAt === '1' ? 'watch' : 'manual'}
                                                usrBrssrHistId={item.usrBrssrHistId}
                                                result={item.rsltCd}
                                                onDelete={() => confirmDelete(item.usrBrssrHistId)}
                                            />
                                        </li>
                                    ))}
                                </ul>
                                {visibleCount < recordList.length && (
                                    <div ref={observerRef} style={{ height: '1px' }} />
                                )}
                            </div>
                        </div>
                    </>
                }

                <div className="bottom-fixed-box">
                    <div className="inner-box" data-bg-color="transparent">
                        <div className='btn-layout' data-btn-num="1">
                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={() => navigate(URL.BLOOD_PRESSURE_WRITE)}>
                                <span>혈압 기록하기</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'><p>기록을 삭제하시겠어요?</p></div>
                    </div>
                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={() => setIsOpen(false)}><span>아니요</span></button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleConfirmDelete}><span>네</span></button>
                        </div>
                    </div>
                </div>
            </Modal>


            <BottomSheetBase open={guideOpen} onDismiss={() => setGuideOpen(false)} maxHeight="75vh"
                    footer={
                        <div>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                                style={{ width: '100%' }}
                                onClick={() => setGuideOpen(false)}>
                                <span>확인</span>
                            </button>
                        </div>
                    }
                >
                    <div className={style['guide-sheet-wrap']}>
                        <h3>혈압 기록 가이드</h3>
                        <ul className={style['guide-content']}>
                            <li>
                                고혈압이란 위 팔에 혈압대를 감아 측정한 동맥의 압력을 기준으로
                                수축기혈압 140 mmHg 이상, 또는 이완기혈압(확장기혈압) 90 mmHg 이상인 경우를 말합니다.
                                수축기혈압과 이완기혈압 모두 120 mmHg와 80 mmHg 미만일 때 정상 혈압이라고 합니다.
                            </li>
                        </ul>
                        <table>
                            <thead>
                                <tr>
                                    <th>구분</th>
                                    <th>수축기 (상압)</th>
                                    <th>이완기 (하압)</th>
                                    <th>설명</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>정상</td>
                                    <td>120 미만</td>
                                    <td>80 미만</td>
                                    <td>이상적 혈압</td>
                                </tr>
                                <tr>
                                    <td>주의</td>
                                    <td>120 ~ 139</td>
                                    <td>80 ~ 89</td>
                                    <td>고혈압 전단계 / 주의 필요</td>
                                </tr>
                                <tr>
                                    <td>위험</td>
                                    <td>140 이상</td>
                                    <td>90 이상</td>
                                    <td>고혈압</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </BottomSheetBase>


            {/* 삼성 헬스 권한 허용 팝업 */}
            <Modal isOpen={permOpen} setIsOpen={setPermOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'><p>{needsInstall ? '삼성 헬스 설치' : '권한 허용'}</p></div>
                        <div className='sub-box'>
                            {needsInstall ? (
                                <span>갤럭시 워치에서 측정한 혈압 데이터를 <br />
                                      가져오려면 삼성 헬스 앱이 필요합니다. <br />
                                        <br />
                                      스토어에서 삼성 헬스를 설치해 주세요.
                                </span>
                            ) : (
                                <span>갤럭시 워치에서 측정한 걸음수·운동·혈압 데이터를 <br />
                                      자동으로 가져오기 위해 권한 동의가 필요합니다. <br />
                                        <br />
                                      권한 허용은 설정 &gt; 데이터권한에서 할 수 있습니다.
                                </span>
                            )}
                        </div>
                    </div>
                    
                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={() => setPermOpen(false)}><span>취소</span></button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handlePermConfirm}>
                                <span>{needsInstall ? '설치하러 가기' : '권한 허용하기'}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {toast && (
                <ToastPopup setToast={setToast} message={toastMessage} position="center" opacity="90" />
            )}
        </>
    );
};

export default BloodPressureRecord;